import { Children } from "react";
import { Box } from "@mui/material";

const timelineDotColors = {
  error: "error.main",
  primary: "primary.main",
  success: "success.main",
  warning: "warning.main",
};

export const Masonry = ({ children, columns = 2, spacing = 1, sx, ...props }) => (
  <Box
    component="div"
    sx={{
      columnCount: columns,
      columnGap: spacing,
      width: "100%",
      ...sx,
    }}
    {...props}
  >
    {Children.map(children, (child, index) => (
      <Box
        component="div"
        key={child?.key ?? index}
        sx={{ breakInside: "avoid", mb: spacing }}
      >
        {child}
      </Box>
    ))}
  </Box>
);
